import React, { useState, useEffect } from 'react';

const RotatingText = ({ texts = [], interval = 3000, initialDelay = 500 }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Initial delay before starting the rotation
    const delayTimer = setTimeout(() => {
      setIsVisible(true);
      
      if (texts.length <= 1) return;
      
      let timeout;
      const timer = setInterval(() => {
        // Start fade out
        setCurrentIndex(prev => {
          const nextIndex = (prev + 1) % texts.length;
          // Set a delay before starting next transition
          clearTimeout(timeout);
          timeout = setTimeout(() => {
            setCurrentIndex(nextIndex);
          }, 300); // Increased delay between transitions
          return prev;
        });
      }, interval + 1000); // Added 1 second to the interval

      return () => {
        clearInterval(timer);
        clearTimeout(timeout);
      };
    }, initialDelay);

    return () => {
      clearTimeout(delayTimer);
    };
  }, [texts.length, interval, initialDelay]);

  if (!texts || texts.length === 0) return null;

  if (!isVisible) return null;
  
  return (
    <div className="relative w-full h-10 sm:h-8 mb-6 sm:mb-8" style={{
      perspective: '1000px',
      transformStyle: 'preserve-3d'
    }}>
      {texts.map((text, index) => {
        const isActive = index === currentIndex;
        return (
          <p 
            key={index}
            className={`absolute left-1/2 transform -translate-x-1/2 px-2 text-center transition-all duration-700 ease-in-out ${
              isActive 
                ? 'opacity-100 translate-y-0 blur-none' 
                : 'opacity-0 translate-y-2 blur-sm pointer-events-none'
            }`}
            style={{
              textShadow: '0 1px 2px rgba(0,0,0,0.3)',
              color: '#f8fafc',
              fontSize: 'clamp(0.875rem, 3vw, 1.25rem)',
              lineHeight: '1.4',
              fontWeight: '450',
              width: '100%',
              maxWidth: '90vw',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
              WebkitFontSmoothing: 'antialiased',
              MozOsxFontSmoothing: 'grayscale',
              backfaceVisibility: 'hidden',
              willChange: 'opacity, transform',
              transform: isActive ? 'translate3d(-50%, 0, 0)' : 'translate3d(-50%, 10px, 0)',
              opacity: isActive ? 1 : 0,
              transition: 'opacity 800ms cubic-bezier(0.2, 0, 0.1, 1), transform 800ms cubic-bezier(0.2, 0, 0.1, 1)'
            }}
          >
            {text}
          </p>
        );
      })}
    </div>
  );
};

export default RotatingText;
